/* eslint-disable */
<template>
  <div>
    <TrendBanner />
    <div class="container-fluid bg-white trent pt-5 pb-5">
      <div class="boxes">
        <div>
          <h4>T-SHIRTS</h4>
          <div class="underline-green"></div>
          <ProductCard v-for="product in tshirt.slice(0, 4)" :key="product.id" :product="product" />
        </div>
        <div>
          <h4>SHOES</h4>
          <div class="underline-green"></div>
          <ProductCard v-for="product in shoes.slice(0, 4)" :key="product.id" :product="product" />
        </div>
        <div>
          <h4>BAGS</h4>
          <div class="underline-green"></div>
          <ProductCard v-for="product in bags.slice(0, 4)" :key="product.id" :product="product" />
        </div>
      </div>
    </div>
    <div class="container-fluid bg-grayish-white trent pt-5 pb-5">
      <div class="boxes">
        <div>
          <h4>BELTS</h4>
          <div class="underline-green"></div>
          <ProductCard v-for="product in belts.slice(0, 3)" :key="product.id" :product="product" />
        </div>
        <div>
          <h4>KIDS</h4>
          <div class="underline-green"></div>
          <ProductCard v-for="product in kids.slice(0, 3)" :key="product.id" :product="product" />
        </div>
        <div>
          <h4>JEANS</h4>
          <div class="underline-green"></div>
          <ProductCard v-for="product in jeans.slice(0, 3)" :key="product.id" :product="product" />
        </div>
      </div>
    </div>
    <LoadingComponent v-if="loading" />
  </div>
</template>

<script>
import ProductCard from "../components/ProductCard";
import TrendBanner from "../components/TrendBanner";
import LoadingComponent from "../components/LoadingComponent";
export default {
  name: "Trends",
  components: {
    ProductCard,
    TrendBanner,
    LoadingComponent
  },
  data() {
    return {
      loading: true
    };
  },
  computed: {
    // GET PRODUCT BY CATEGORY

    // GET T-SHIRT PRODUCT
    tshirt() {
      let cat = "T-shirt";
      return this.$store.getters.productByCategory(cat);
    },

    // GET SHOES PRODUCT
    shoes() {
      let cat = "Shoes";
      return this.$store.getters.productByCategory(cat);
    },

    // GET BAGS PRODUCT
    bags() {
      let cat = "Bags";
      return this.$store.getters.productByCategory(cat);
    },

    // GET BELTS PRODUCT
    belts() {
      let cat = "Belt";
      return this.$store.getters.productByCategory(cat);
    },

    // GET JEANS PRODUCT
    jeans() {
      let cat = "Jeans";
      return this.$store.getters.productByCategory(cat);
    },

    // GET KIDS PRODUCT
    kids() {
      let cat = "Kids";
      return this.$store.getters.productByCategory(cat);
    }
  },
  methods: {
    // WHEN PAGE LOADS, SHOW LOADING
    processLoading: function() {
      setTimeout(() => {
        this.closeLoading();
      }, 3000);
    },
    closeLoading: function() {
      if (this.loading) {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.processLoading();
    this.$store.dispatch("getAllProducts");
    this.$store.state.showSearch = false;
  }
};
</script>

<style scoped></style>
